import { GlobalToken, Table } from "antd";
import styled from "styled-components";

export const CustomTable = styled(Table)`
  .ant-table {
    background: rgba(104, 72, 120, 0.05) !important;
  }
  .ant-table-thead > tr > th {
    background: rgba(34, 39, 47, 1) !important;
  }
  .ant-table-tbody > tr.ant-table-row {
    //border-radius: 45px;
  }
  .ant-table-tbody > tr.ant-table-row td:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .ant-table-tbody > tr.ant-table-row td:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: var(--primary-500) !important;
  }
`;
export const Container = styled.div<{ token: GlobalToken }>`
  /* background: var(--landing-background); */
  display: flex !important;
  flex-direction: column;
  /* align-items: flex-start; */
  /* justify-content: space-between; */
  margin-top: 100px;
  padding-left: 12.5rem !important;
  padding-right: 12.5rem !important;
  gap: 24px;
  position: relative;

  .ant-pagination {
    display: flex;
    .ant-pagination-total-text {
      margin-right: auto;
    }
  }
  .ant-progress-steps-item {
    border-radius: 6px;
  }
  .ant-table-content {
    overflow: auto;
  }
  table {
    overflow: auto;
    tr {
      td,
      th {
        white-space: nowrap;
        border-bottom: 20px solid
          ${({ token }) => token.colorBgLayout}!important;
      }
    }
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #cd6eff17 !important;
  }

  @media (min-width: 1440px) {
    /*  */
  }
  @media (max-width: 1439px) {
    /* .m-point-text {
      font-weight: 300;
      font-size: 18px;
      line-height: 28px;
    } */
  }
  @media (max-width: 768px) {
    padding-left: 16px !important ;
    padding-right: 16px !important;
  }
  @media (max-width: 425px) {
    padding-left: 16px !important ;
    padding-right: 16px !important;
  }
`;
